/**
 * Brand glyphs for the site footer's social row.
 *
 * The legacy footer gets these from Font Awesome 6 Free (`<i class="fab …">`),
 * plus one inline Bootstrap-Icons SVG for X. Neither package is a dependency
 * here and adding ~1.4MB of icon font for seven glyphs would not survive the
 * bundle-cost question in .claude/rules/performance.md — so these are inline,
 * filled paths driven by currentColor.
 *
 * Filled (not stroked) on purpose: brand marks read wrong as outlines, which is
 * why these don't share the stroked `base` used by icons.jsx.
 */
const base = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 16 16',
  fill: 'currentColor',
  'aria-hidden': 'true',
  focusable: 'false',
};

function Facebook(props) {
  return (
    <svg {...base} {...props}>
      <path d="M16 8.05C16 3.6 12.42 0 8 0S0 3.6 0 8.05C0 12.07 2.93 15.4 6.75 16v-5.62H4.72V8.05h2.03V6.28c0-2.02 1.2-3.13 3.02-3.13.88 0 1.79.16 1.79.16v1.97h-1.01c-.99 0-1.3.62-1.3 1.26v1.51h2.22l-.36 2.33H9.25V16C13.07 15.4 16 12.07 16 8.05Z" />
    </svg>
  );
}

function Instagram(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8 0C5.83 0 5.56.01 4.7.05c-.86.04-1.44.17-1.95.37-.53.2-.98.48-1.43.93-.45.45-.73.9-.93 1.43-.2.51-.33 1.09-.37 1.95C.01 5.56 0 5.83 0 8s.01 2.44.05 3.3c.04.86.17 1.44.37 1.95.2.53.48.98.93 1.43.45.45.9.73 1.43.93.51.2 1.09.33 1.95.37.86.04 1.13.05 3.3.05s2.44-.01 3.3-.05c.86-.04 1.44-.17 1.95-.37.53-.2.98-.48 1.43-.93.45-.45.73-.9.93-1.43.2-.51.33-1.09.37-1.95.04-.86.05-1.13.05-3.3s-.01-2.44-.05-3.3c-.04-.86-.17-1.44-.37-1.95-.2-.53-.48-.98-.93-1.43-.45-.45-.9-.73-1.43-.93-.51-.2-1.09-.33-1.95-.37C10.44.01 10.17 0 8 0Zm0 1.44c2.14 0 2.39.01 3.23.05.78.03 1.2.16 1.49.27.37.15.64.32.92.6.28.28.45.55.6.92.11.28.24.71.27 1.49.04.84.05 1.1.05 3.23s-.01 2.39-.05 3.23c-.03.78-.16 1.2-.27 1.49-.15.37-.32.64-.6.92-.28.28-.55.45-.92.6-.28.11-.71.24-1.49.27-.84.04-1.1.05-3.23.05s-2.39-.01-3.23-.05c-.78-.03-1.2-.16-1.49-.27a2.48 2.48 0 0 1-.92-.6 2.48 2.48 0 0 1-.6-.92c-.11-.28-.24-.71-.27-1.49-.04-.84-.05-1.1-.05-3.23s.01-2.39.05-3.23c.03-.78.16-1.2.27-1.49.15-.37.32-.64.6-.92.28-.28.55-.45.92-.6.28-.11.71-.24 1.49-.27.84-.04 1.1-.05 3.23-.05Z" />
      <path d="M8 10.67a2.67 2.67 0 1 1 0-5.34 2.67 2.67 0 0 1 0 5.34Zm0-6.78a4.11 4.11 0 1 0 0 8.22 4.11 4.11 0 0 0 0-8.22Zm5.24-.17a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0Z" />
    </svg>
  );
}

function LinkedIn(props) {
  return (
    <svg {...base} {...props}>
      <path d="M0 1.15C0 .51.53 0 1.19 0h13.62C15.47 0 16 .51 16 1.15v13.7c0 .64-.53 1.15-1.19 1.15H1.19C.53 16 0 15.49 0 14.85V1.15Zm4.94 12.22V6.17H2.54v7.2h2.4Zm-1.2-8.18c.84 0 1.36-.55 1.36-1.24-.02-.7-.52-1.24-1.34-1.24-.82 0-1.36.54-1.36 1.24 0 .69.52 1.24 1.33 1.24h.01Zm4.42 8.18V9.35c0-.21.02-.43.08-.59.17-.43.56-.88 1.22-.88.86 0 1.2.66 1.2 1.62v3.87h2.4V9.22c0-2.22-1.18-3.25-2.76-3.25-1.27 0-1.84.7-2.16 1.19v.02h-.02l.02-.02V6.17h-2.4c.03.68 0 7.2 0 7.2h2.4Z" />
    </svg>
  );
}

function Twitch(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3.86 0 .93 2.93v10.14h3.47V16l2.93-2.93h2.4L15 8V0H3.86Zm9.94 7.47-2.13 2.13H9.53L7.67 11.47V9.6H5.27V1.07h8.53v6.4Z" />
      <path d="M12.2 2.93h-1.07V6.4h1.07V2.93Zm-2.94 0H8.2V6.4h1.06V2.93Z" />
    </svg>
  );
}

function X(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
    </svg>
  );
}

function YouTube(props) {
  return (
    <svg {...base} {...props}>
      <path d="M8.05 3.5h.09c.83.01 5.02.04 6.15.34.34.1.65.27.91.52.25.25.43.57.52.91.1.38.17.88.22 1.4l.01.1.02.25.01.1c.05.9.06 1.74.06 1.92v.08c0 .19-.01 1.08-.06 2.02l-.01.1-.01.11c-.05.56-.12 1.12-.23 1.53-.09.34-.27.66-.52.9-.26.26-.57.44-.91.53-1.17.31-5.6.33-6.23.33h-.15c-.32 0-1.64-.01-3.03-.06l-.17-.01-.09-.01-.18-.01-.18-.01c-1.15-.05-2.24-.14-2.74-.27a2.07 2.07 0 0 1-.91-.52 2.07 2.07 0 0 1-.52-.91c-.11-.4-.18-.97-.23-1.53l-.01-.11-.01-.1A32.6 32.6 0 0 1 0 9.1v-.2c0-.21.01-.93.05-1.72l.01-.11v-.1l.02-.25.01-.1c.05-.52.12-1.03.22-1.4.09-.35.27-.66.52-.91.26-.25.57-.43.91-.52.5-.13 1.59-.22 2.74-.28l.18-.01.18-.01.09-.01.17-.01c.99-.03 1.98-.05 2.97-.05ZM6.4 6.03v4.94l4.26-2.47-4.26-2.47Z" />
    </svg>
  );
}

function Envelope(props) {
  return (
    <svg {...base} {...props}>
      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.22l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.38-4.7 2.82L15 10.9V5.38Zm-.05 6.67L9.4 8.72 8 9.56l-1.4-.84-5.55 3.33A1 1 0 0 0 2 13h12a1 1 0 0 0 .95-.95ZM1 10.9l4.7-2.7L1 5.38v5.52Z" />
    </svg>
  );
}

/** Lookup used by the footer: `icon` key in config/footerLinks → component. */
export const SOCIAL_ICONS = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: LinkedIn,
  twitch: Twitch,
  x: X,
  youtube: YouTube,
  envelope: Envelope,
};
